import { useI18n } from 'vue-i18n';

/**
 * Returns a helper that turns a backend validation code into a readable message.
 * - Translates known codes (e.g. "required", "min:8") via the errors.* namespace.
 * - Falls back to the raw backend message when no translation exists.
 *
 * Usage: const err = useValidation(errors); ... :error="err('name')"
 */
export function useValidation(errorsRef) {
    const i18n = useI18n();

    const label = (field) => {
        for (const key of [`fields.${field}`, `portal.fields.${field}`]) {
            if (i18n.te(key)) return i18n.t(key);
        }
        return field;
    };

    return (field) => {
        const code = errorsRef.value?.[field];
        if (!code) return '';
        const key = `errors.${code}`;
        return i18n.te(key) ? i18n.t(key, { field: label(field) }) : code;
    };
}

export default useValidation;
